import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_CURRENT_ENTITY = 'SET_CURRENT_ENTITY';
export const RESET_CURRENT_ENTITY = 'RESET_CURRENT_ENTITY';

export const setCurrentEntity = makeActionCreator(SET_CURRENT_ENTITY);
export const resetCurrentEntity = makeActionCreator(RESET_CURRENT_ENTITY);
